// Conformité — Tableau suivi financier par installateur.
// Réservé admin/commercial (les installateurs externes ne doivent pas
// voir les données financières des autres). Filtrage role-based géré
// au niveau catalogue serveur.
import { Hammer, Loader2 } from "lucide-react";
import { Badge } from "../../components/ui/badge";
import { useConformiteFetch, fmtEuro } from "./useConformiteFetch";

export default function ConformiteParInstallateurWidget() {
  const { data, loading, error } = useConformiteFetch();

  if (loading) {
    return (
      <div
        className="rounded-xl p-5 h-full flex items-center justify-center"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      >
        <Loader2 className="w-5 h-5 animate-spin" style={{ color: "var(--oh-text-muted)" }} />
      </div>
    );
  }
  if (error) {
    return (
      <div
        className="rounded-xl p-5"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)", color: "var(--oh-text-muted)" }}
      >
        Erreur Installateurs : {error}
      </div>
    );
  }

  const items = data?.par_installateur || [];

  return (
    <div
      className="rounded-xl p-5 h-full"
      style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      data-testid="conformite-par-installateur-widget"
    >
      <h3 className="font-semibold mb-4 flex items-center gap-2" style={{ color: "var(--oh-text)" }}>
        <Hammer className="w-4 h-4" style={{ color: "var(--oh-stat-cyan-text)" }} />
        Installateurs — Suivi financier ({items.length})
      </h3>
      <div className="overflow-x-auto oh-responsive-table">
        <table className="w-full text-sm">
          <thead>
            <tr style={{ borderBottom: "1px solid var(--oh-border)" }}>
              {["Installateur", "Dossiers", "Devis total", "Prime ANAH", "Reste à charge", "Avances payées", "Soldes"].map((h) => (
                <th key={h} className="text-left p-3 text-xs font-medium" style={{ color: "var(--oh-text-muted)" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {items.map((inst) => (
              <tr key={inst.installateur} className="border-t" style={{ borderColor: "var(--oh-border)" }}>
                <td className="p-3 font-medium" style={{ color: "var(--oh-text)" }}>{inst.installateur}</td>
                <td className="p-3" style={{ color: "var(--oh-text-secondary)" }}>
                  <Badge style={{ background: "#3b82f620", color: "var(--oh-stat-blue-text)", border: "none" }}>
                    {inst.count}
                  </Badge>
                </td>
                <td className="p-3 font-mono text-xs" style={{ color: "#8b5cf6" }}>{fmtEuro(inst.montant_devis_total)}</td>
                <td className="p-3 font-mono text-xs" style={{ color: "#10b981" }}>{fmtEuro(inst.montant_prime_total)}</td>
                <td className="p-3 font-mono text-xs" style={{ color: "var(--oh-stat-amber-text)" }}>{fmtEuro(inst.reste_charge_total)}</td>
                <td className="p-3 text-center">
                  {inst.avec_avance > 0 ? (
                    <Badge style={{ background: "#10b98120", color: "#10b981", border: "none" }}>{inst.avec_avance}</Badge>
                  ) : <span style={{ color: "var(--oh-text-muted)" }}>-</span>}
                </td>
                <td className="p-3 text-center">
                  {inst.paye > 0 ? (
                    <Badge style={{ background: "#22c55e20", color: "var(--oh-stat-green-text)", border: "none" }}>{inst.paye}</Badge>
                  ) : <span style={{ color: "var(--oh-text-muted)" }}>-</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {items.length === 0 && (
          <div className="text-center py-8 text-xs" style={{ color: "var(--oh-text-muted)" }}>Aucun installateur</div>
        )}
      </div>
    </div>
  );
}
